<div class="row wrapper border-bottom white-bg page-heading" *ngIf="!public && dashboardListId == null && showBanner">
    <div class="col-lg-8 col-md-6 col-xs-11">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
            <a [routerLink]="['/dashboards']">Dashboard List</a>
        </li>
        <li class="breadcrumb-item" *ngIf="dashboardList">
            <a>{{dashboardList.listName}}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="dashboardListItem">
            <a>{{dashboardListItem.name}}</a>
        </li>
      </ol>
    </div>
</div>
  
<div *ngIf="loading" class="animate__animated animate__fadeIn mt-3" >
    <div class="spinner-border text-success"></div>
</div>

<!-- Dashboard Display -->
<div class="animate__animated animate__fadeIn" *ngIf="dashboardListItem">
    <app-dashboard #embeddedDashboard  [dashboardId]="dashboardListItem.dashboardId" [delayLoad]="true" [showBanner]="false" [showEditor]="false" [siteUri]="dashboardListItem.siteUri"></app-dashboard>
</div>

